import { render, staticRenderFns } from "./ChangeAccountDiscountBtn.vue?vue&type=template&id=17980c46&"
import script from "./ChangeAccountDiscountBtn.vue?vue&type=script&lang=js&"
export * from "./ChangeAccountDiscountBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports